let browserHeight = window.innerHeight|| document.documentElement.clientHeight || document.body.clientHeight;
let browserWidth = window.innerWidth|| document.documentElement.clientWidth || document.body.clientWidth;

let scrollPosition = window.pageYOffset,
  lastScrollPosition = scrollPosition,
  ticking = false;

const body = document.body,
  header = document.querySelector(".header"),
  scrollCutoff = header.offsetHeight;

const parallaxElements = document.querySelectorAll('.parallax');

document.querySelectorAll('.check-in-view').forEach((i) => {
  if (i) {
      const observer = new IntersectionObserver((entries) => {
          observerCallback(entries, observer, i)
      },
      {threshold: 0.5});    
      observer.observe(i);
  }
});

const observerCallback = (entries, observer, header) => {
  entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
      } else {
          entry.target.classList.remove('is-in-view');
      }
  });
};

Number.prototype.clamp = function(min, max) {
  return Math.min(Math.max(this, min), max);
};

const parallax = elements => {
  if ('undefined' !== elements && elements.length > 0) {
    elements.forEach( element => {
      let parallaxAmount = element.dataset.parallax ? element.dataset.parallax : 0.4;
      let y = (window.pageYOffset - element.getBoundingClientRect().top)/2;
        element.style.transform = 'translateY(' + parallaxAmount * y.clamp(0,1000) + "px)";
    })
  }
}

function nucleoHeaderPosition() {
  scrollPosition = window.pageYOffset;
    if (scrollPosition > scrollCutoff) {
      header.classList.add("header--is-opaque");
        if(scrollPosition > lastScrollPosition) {
          body.classList.remove("scrolling-up");
          header.classList.add("header--is-hidden");
        } else {
          body.classList.add("scrolling-up");
          header.classList.remove("header--is-hidden");
        }
    } else {
      header.classList.remove("header--is-opaque");
    }
  lastScrollPosition = scrollPosition;
}

window.addEventListener("scroll", function() {
  if (!ticking) {
    window.requestAnimationFrame(function() {
      nucleoHeaderPosition();
      parallax(parallaxElements);
      ticking = false;
    });
    ticking = true;
  }
});

window.addEventListener("resize", function() {
    nucleoHeaderPosition();
    parallax(parallaxElements);
});

document.addEventListener('DOMContentLoaded', (event) => {
  parallax(parallaxElements);
  nucleoHeaderPosition();
});